import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
} from "recharts";
import Styles from "../../../styles/report/mobile/biohexagonmobile.module.scss";

const BiometrichexagonMobile = ({ report }) => {

  // const biometricData = [
  //   {
  //     block: 1,
  //     bodyWeight: report?.[0]?.body?.weight || 0,
  //     muscleGass: report?.[0]?.body?.muscle || 0,
  //     bodyFat: report?.[0]?.body?.fat || 0,
  //   },
  //   {
  //     block: 2,
  //     bodyWeight: report?.[1]?.body?.weight || 0,
  //     muscleGass: report?.[1]?.body?.muscle || 0,
  //     bodyFat: report?.[1]?.body?.fat || 0,
  //   },
  //   {
  //     block: 3,
  //     bodyWeight: report?.[2]?.body?.weight || 0,
  //     muscleGass: report?.[2]?.body?.muscle || 0,
  //     bodyFat: report?.[2]?.body?.fat || 0,
  //   },
  //   {
  //     block: 4,
  //     bodyWeight: report?.[3]?.body?.weight || 0,
  //     muscleGass: report?.[3]?.body?.muscle || 0,
  //     bodyFat: report?.[3]?.body?.fat || 0,
  //   },
  // ];

  // const radarData = [
  //   {
  //     exercise:report?.[0]?.workouts?.[0]?.workout.name ||  "",
  //     block1: report?.[0]?.workouts?.[0]?.unifiedMetricScore || 20,
  //     block2: report?.[1]?.workouts?.[0]?.unifiedMetricScore || 40,
  //     block3: report?.[2]?.workouts?.[0]?.unifiedMetricScore || 30,
  //     block4: report?.[3]?.workouts?.[0]?.unifiedMetricScore || 35,
  //   },
  //   {
  //     exercise:report?.[0]?.workouts?.[1]?.workout.name || "",
  //     block1: report?.[0]?.workouts?.[1]?.unifiedMetricScore || 30,
  //     block2: report?.[1]?.workouts?.[1]?.unifiedMetricScore || 50,
  //     block3: report?.[2]?.workouts?.[1]?.unifiedMetricScore || 40,
  //     block4: report?.[3]?.workouts?.[1]?.unifiedMetricScore || 45,
  //   },
  //   {
  //     exercise:report?.[0]?.workouts?.[2]?.workout.name || "",
  //     block1: report?.[0]?.workouts?.[2]?.unifiedMetricScore || 25,
  //     block2: report?.[1]?.workouts?.[2]?.unifiedMetricScore || 45,
  //     block3: report?.[2]?.workouts?.[2]?.unifiedMetricScore || 35,
  //     block4: report?.[3]?.workouts?.[2]?.unifiedMetricScore || 40,
  //   },
  //   {
  //     exercise: report?.[0]?.workouts?.[3]?.workout.name || "",
  //     block1: report?.[0]?.workouts?.[3]?.unifiedMetricScore || 35,
  //     block2: report?.[1]?.workouts?.[3]?.unifiedMetricScore || 55,
  //     block3: report?.[2]?.workouts?.[3]?.unifiedMetricScore || 45,
  //     block4: report?.[3]?.workouts?.[3]?.unifiedMetricScore || 50,
  //   },
  //   {
  //     exercise: report?.[0]?.workouts?.[4]?.workout.name || "",
  //     block1: report?.[0]?.workouts?.[4]?.unifiedMetricScore || 40,
  //     block2: report?.[1]?.workouts?.[4]?.unifiedMetricScore || 60,
  //     block3: report?.[2]?.workouts?.[4]?.unifiedMetricScore || 50,
  //     block4: report?.[3]?.workouts?.[4]?.unifiedMetricScore || 55,
  //   },
  //   {
  //     exercise: report?.[0]?.workouts?.[5]?.workout.name || "",
  //     block1: report?.[0]?.workouts?.[5]?.unifiedMetricScore || 30,
  //     block2: report?.[1]?.workouts?.[5]?.unifiedMetricScore || 50,
  //     block3: report?.[2]?.workouts?.[5]?.unifiedMetricScore || 40,
  //     block4: report?.[3]?.workouts?.[5]?.unifiedMetricScore || 45,
  //   },
  // ];


 // Sort reports by block and map by block number
  const sortedReports = React.useMemo(() => {
    return Array.isArray(report)
      ? [...report].sort(
          (a, b) =>
            (a?.block ?? Number.MAX_SAFE_INTEGER) -
            (b?.block ?? Number.MAX_SAFE_INTEGER)
        )
      : [];
  }, [report]);

  const reportsByBlock = React.useMemo(
    () =>
      new Map(
        sortedReports
          .filter((r) => Number.isFinite(r?.block))
          .map((r) => [r.block, r])
      ),
    [sortedReports]
  );

  // Table: always 4 blocks; fill when data exists
  const biometricData = React.useMemo(
    () =>
      Array.from({ length: 4 }, (_, i) => {
        const block = i + 1;
        const r = reportsByBlock.get(block);
        return {
          block,
          bodyWeight: r?.body?.weight ?? "-",
          muscleGass: r?.body?.muscle ?? "-",
          bodyFat: r?.body?.fat ?? "-",
        };
      }),
    [reportsByBlock]
  );

  // Chart: values per block number
  const radarData = React.useMemo(
    () =>
      Array.from({ length: 6 }, (_, idx) => {
        const getName = () => {
          for (let b = 1; b <= 4; b++) {
            const name = reportsByBlock.get(b)?.workouts?.[idx]?.workout?.name;
            if (name) return name;
          }
          return "";
        };
        return {
          exercise: getName(),
          block1: reportsByBlock.get(1)?.workouts?.[idx]?.unifiedMetricScore,
          block2: reportsByBlock.get(2)?.workouts?.[idx]?.unifiedMetricScore,
          block3: reportsByBlock.get(3)?.workouts?.[idx]?.unifiedMetricScore,
          block4: reportsByBlock.get(4)?.workouts?.[idx]?.unifiedMetricScore,
        };
      }),
    [reportsByBlock]
  );

  return (
    <div className={Styles.container}>
      {/* Biometric Report Title - Outside the Box */}
      <h2 className={Styles.mainTitle}>BIOMETRIC REPORT</h2>

      {/* Biometric Report Table */}
      <div className={Styles.biometricSection}>
        <div className={Styles.tableContainer}>
          <div className={Styles.tableRow}>
            <div  className={Styles.tableHeader}>Block</div>
            <div className={Styles.tableHeader}>1</div>
            <div className={Styles.tableHeader}>2</div>
            <div className={Styles.tableHeader}>3</div>
            <div className={Styles.tableHeader}>4</div>
          </div>

          <div className={Styles.tableRow}>
            <div className={Styles.tableRowHeader}>Body Weight (kg)</div>
            <div className={Styles.tableCell}>{biometricData[0].bodyWeight}</div>
            <div className={Styles.tableCell}>{biometricData[1].bodyWeight}</div>
            <div className={Styles.tableCell}>{biometricData[2].bodyWeight}</div>
            <div className={Styles.tableCell}>{biometricData[3].bodyWeight}</div>
          </div>

          <div className={Styles.tableRow}>
            <div className={Styles.tableRowHeader}>Muscle Mass (kg)</div>
            <div className={Styles.tableCell}>{biometricData[0].muscleGass}</div>
            <div className={Styles.tableCell}>{biometricData[1].muscleGass}</div>
            <div className={Styles.tableCell}>{biometricData[2].muscleGass}</div>
            <div className={Styles.tableCell}>{biometricData[3].muscleGass}</div>
          </div>

          <div className={Styles.tableRow}>
            <div className={Styles.tableRowHeader}>Body Fat (%)</div>
            <div className={Styles.tableCell}>{biometricData[0].bodyFat}</div>
            <div className={Styles.tableCell}>{biometricData[1].bodyFat}</div>
            <div className={Styles.tableCell}>{biometricData[2].bodyFat}</div>
            <div className={Styles.tableCell}>{biometricData[3].bodyFat}</div>
          </div>
        </div>
      </div>
   <h2 className={Styles.sectionTitle }>EXERCISE CHART </h2>
      {/* Hexagon Radar Chart */}
      <div className={Styles.categorySection}>
           
        <div className={Styles.chartWrapper}>
          {/* Hexagon Chart */}
          <div className={Styles.chartContainer}>
            <ResponsiveContainer width="100%" height={300}>
              <RadarChart
                data={radarData}
                margin={{ top: 40, right: 40, bottom: 40, left: 40 }}
              >
                <PolarGrid
                  gridType="polygon"
                  radialLines={true}
                  stroke="#404040"
                  strokeWidth={1}
                />
                <PolarAngleAxis
                  dataKey="exercise"
                  tick={{ fontSize: 12, fill: "#696D6E", fontWeight: 600 }}
                />
                <Radar
                  name="Block 1"
                  dataKey="block1"
                  stroke="#666666"
                  fill="#666666"
                  fillOpacity={0.4}
                  strokeWidth={2}
                />
                <Radar
                  name="Block 2"
                  dataKey="block2"
                  stroke="#ff8c42"
                  fill="#ff8c42"
                  fillOpacity={0.6}
                  strokeWidth={2}
                />
                <Radar
                  name="Block 3"
                  dataKey="block3"
                  stroke="#ffffff"
                  fill="#ffffff"
                  fillOpacity={0.3}
                  strokeWidth={2}
                />
                <Radar
                  name="Block 4"
                  dataKey="block4"
                  stroke="#BB6307"
                  fill="#BB6307"
                  fillOpacity={0.5}
                  strokeWidth={2}
                />
              </RadarChart>
            </ResponsiveContainer>
          </div>

          {/* Legend */}
          <div className={Styles.legend}>
            <div className={Styles.legendItem}>
              <div className={`${Styles.legendColor} ${Styles.gray}`}></div>
              <span className={Styles.legendText}>BLOCK 1</span>
            </div>
            <div className={Styles.legendItem}>
              <div className={`${Styles.legendColor} ${Styles.light_orange}`}></div>
              <span className={Styles.legendText}>BLOCK 2</span>
            </div>
            <div className={Styles.legendItem}>
              <div className={`${Styles.legendColor} ${Styles.white}`}></div>
              <span className={Styles.legendText}>BLOCK 3</span>
            </div>
            <div className={Styles.legendItem}>
              <div className={`${Styles.legendColor} ${Styles.dark_orange}`}></div>
              <span className={Styles.legendText}>BLOCK 4</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiometrichexagonMobile;